export class environment {
    public static ProductionEnv: any;
    public static production: any;
    public static title: any;
    public static env: any;
    public static HostUri: any;
    public static ApiHostUri: any;
    public static tenant: any;
    public static clientId: any;
    public static resourceId: any;
    public static ApiBaseUri: any;
    public static ApiBasePOAUri: any;
    public static ApiBaseAuditTrailUri: any;
    public static OcpSubscriptionKey: any;
    public static logOut: any;
     public static ApiBaseBrokerageFeeUri:any;
    public static ApiBaseIECUri:any;
    public static ApiBaseIECBulkUri:any;
    public static ApiBaseWCUri:any;
    public static ApiBaseWCRefUri:string;
    public static ApiBaseCountryFieldUri:string;
    public static ApiBaseDPSUri:string;
    public static scope:any = [
        "profile",
        "openID"
    ];
    public static Authority:any="https://login.microsoftonline.com/e7520e4d-d5a0-488d-9e9f-949faae7dce8";
    public static featureFlags: any;
}